import React, { useEffect, useState, useContext } from 'react';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import AddIcon from '@material-ui/icons/Add';
import Modal from '@material-ui/core/Modal';
import InvoiceForm from './InvoiceForm';
import GenericDialogBox from '../../components/GenericDialogBox';
import InfoBox from '../../components/InfoBox';
import DataService from "../../services/data.service";
import PatchedPagination from '../../components/PatchedPagination'
import { useTranslation } from "react-i18next";
import { parseISO, format } from 'date-fns';
import InvoicePrint from '../../components/Invoice/InvoicePrint';
import PermissionContext from '../../contexts/PermissionContext';


const useStyles = makeStyles((theme) => ({

    paper: {
        margin: 'auto',
        overflow: 'hidden',
    },
    searchBar: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },
    searchInput: {
        fontSize: theme.fontSize,
    },
    block: {
        display: 'block',
    },
    addUser: {
        marginRight: theme.spacing(1),
    },
    contentWrapper: {
        margin: '40px 16px',
    },
    fab: {
        position: 'fixed',
        marginTop: '10px'
    },
    modalStyle: {
        position: 'absolute',
        top: '10%',
        left: '10%',
        overflow: 'scroll',
        height: '100%',
        display: 'block',
        marginTop: '-140px',
        marginLeft: '70px'
    }
}));


const InvoiceModal = React.forwardRef((props, ref) => {
    const { handleFormCLose, showForm, idToUpdate, configData, permission } = props;
    const classes = useStyles();

    return (
        <Modal
            className={classes.modalStyle}
            open={showForm}
            onClose={handleFormCLose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >

            <InvoiceForm
                idToUpdate={idToUpdate}
                configData={configData}
                permission={permission}
            />
        </Modal>
    )
})


const baseURL = process.env.REACT_APP_PUBLIC_API_URL

const endpoint = `invoice/`
const configEndpoint = `configuration`

const InvoiceTable = (props) => {
    const { permission } = props;
    const { userHasPermission } = useContext(PermissionContext)

    // console.log("UHP",userHasPermission)

    let hasPerm = userHasPermission(permission, 'can_list')
    let hasAddPerm = userHasPermission(permission, 'can_post')
    let hasEditPerm = userHasPermission(permission, 'can_patch')
    let hasGetPerm = userHasPermission(permission, 'can_get')
    let hasDeletePerm = userHasPermission(permission, 'can_delete')
    // for detail form
    let hasDeleteDetailPerm = userHasPermission(`${permission}-detail`, 'can_delete')

    // console.log(permission)
    const classes = useStyles();
    const { t } = useTranslation();

    const [loading, setLoading] = useState(true);
    const [query, setQuery] = useState("");
    const [data, setData] = useState([]);

    useEffect((query) => {
        setLoading(true)

        if (query) {
            // console.log("query",query)
        } else {
            retrieveData()
        }
        setLoading(false)
    }, [query]);


    const retrieveData = (endpoint) => {
        var varPromise = DataService.getAll(endpoint)
            .catch(e => {
                console.log(e)
                if (e.response.status !== 404) {
                    openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
                } else {
                    // setData({})
                    console.log("Unexpected error: ", e)
                }
            });
        return varPromise
    }

    const deleteData = (id) => {
        var dataDelete = { 'id': id };
        DataService.delete(endpoint, dataDelete)
            .then(response => {
                openNoticeBox("Notice", t("record_deleted_success"))
                retrieveData()
            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
            });
    }

    const [configData, setConfigData] = useState({});
    useEffect(() => {

        retrieveConfigData()
    }, []);

    const retrieveConfigData = () => {
        DataService.getAll(configEndpoint)
            .then(response => {
                let configTemp = {};
                response.data.forEach(cfg => {
                    configTemp[cfg.config_name] = cfg.config_value
                });

                setConfigData(configTemp)
                // console.log(configTemp);
            })
            .catch(e => {
                console.log(e)
                alert(`Error - Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
            });
    }

    // INFO NOTIFICATION VARS
    const [infoOpen, setInfoOpen] = useState(false);
    const [infoTitle, setInfoTitle] = useState('');
    const [infoBody, setInfoBody] = useState('');
    //***********************

    // DELETE DIALOG VARS
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogueTitle, setDialogueTitle] = useState('');
    const [dialogueBody, setDialogueBody] = useState('');
    const [idToDelete, setidToDelete] = useState(null);
    // ************

    // PRINT DIALOG VARS
    const [printDialogOpen, setPrintDialogOpen] = useState(false);
    const [printDialogueTitle, setPrintDialogueTitle] = useState('');
    const [printDialogueBody, setPrintDialogueBody] = useState('');
    const [invoiceObj, setInvoiceObj] = useState({});
    // ************

    // FORM VARS
    const [idToUpdate, setidToUpdate] = useState(null);
    useEffect(() => {
        let isActive = true;
        return () => { isActive = false };
    }, [idToUpdate]);
    const [showForm, setShowForm] = useState(false);

    // FORM FUNCTIONS
    const handleFormCLose = () => {
        tableRef.current.onQueryChange()
        setShowForm(false);
    };

    const handleFormOpen = (id) => {
        // console.log("id",typeof id)
        let newId = typeof id === 'object' ? 0 : id
        setidToUpdate(newId)
        setShowForm(true);
    };
    // ********************

    // Notification INFO functions
    const openNoticeBox = (title, body) => {
        setInfoTitle(title)
        setInfoBody(body)
        setInfoOpen(true)
    };

    const handleInfoClose = () => {
        tableRef.current.onQueryChange()
        setInfoOpen(false)
    };
    // *****************

    // DELETE DIALOG FUNCTIONS
    const handleDialogOk = () => {
        deleteData(idToDelete)
        setDialogOpen(false)
    };

    const handleDialogClose = () => {
        tableRef.current.onQueryChange()
        setidToDelete(null)
        setDialogOpen(false)

    };

    const openDialogBox = (id) => {
        setDialogueTitle(t("delete_record_question"))
        setDialogueBody(t("sure_to_delete_record_question") + id)
        // console.log(dialogOpen, dialogueTitle, dialogueBody)
        setidToDelete(id)
        setDialogOpen(true)
    };

    // const classes = useStyles();

    const tableRef = React.createRef();

    return (
        <Grid container spacing={2} >
            <Grid item xs={12}>
                <GenericDialogBox
                    opn={dialogOpen}
                    handleDialogOk={handleDialogOk}
                    handleDialogClose={handleDialogClose}
                    title={dialogueTitle}
                    body={dialogueBody} />
                <InfoBox
                    opn={infoOpen}
                    handleDialogClose={handleInfoClose}
                    title={infoTitle}
                    body={infoBody} />

                <InvoiceModal
                    handleFormCLose={handleFormCLose}
                    showForm={showForm}
                    idToUpdate={idToUpdate}
                    configData={configData}
                    permission={permission}
                />

                <MaterialTable
                    title={t("invoice_table_title")}
                    tableRef={tableRef}
                    columns={[
                        { title: 'ID', field: 'id' },
                        { title: t("form_table_column_date"), field: 'date', render: rowData => format(parseISO(rowData.date), 'dd/MM/yyyy') },
                        { title: t("form_table_column_invoice"), field: 'invoice' },
                        { title: t("form_table_column_due_date"), field: 'due_date', render: rowData => format(parseISO(rowData.due_date), 'dd/MM/yyyy') },
                        { title: t("form_table_column_client"), field: 'client.name' },
                        { title: t("form_table_column_subtotal"), field: 'subtotal', render: rowData => rowData.subtotal.toFixed(2) },
                        { title: t("form_table_column_discount"), field: 'dct', render: rowData => rowData.dct.toFixed(2) },
                        { title: t("form_table_column_tax"), field: 'tax', render: rowData => rowData.tax.toFixed(2) },
                        { title: t("form_table_column_total"), field: 'total', render: rowData => rowData.total.toFixed(2) },
                        { title: t("form_table_column_collected"), field: 'collected', render: rowData => rowData.collected.toFixed(2) }
                    ]}
                    data={query =>
                        new Promise((resolve, reject) => {
                            let url = `${endpoint}?`
                            if (query.search === "") {
                                // console.log("HERE", query.page, query.pageSize, query)
                                url += 'limit=' + query.pageSize
                                url += query.page === 0 ? '&skip=0' : "&skip=" + (query.pageSize * query.page)
                            } else {
                                // console.log("THERE")
                                url = `${endpoint}search?`
                                url += 'query=' + query.search
                                url += '&limit=' + query.pageSize
                                url += query.page === 0 ? '&skip=0' : "&skip=" + (query.pageSize * query.page)
                            }

                            retrieveData(url)
                                .then(result => {
                                    // console.log("data", result)
                                    if (result) {
                                        resolve({
                                            data: result.data.data,
                                            page: result.data.page,
                                            totalCount: result.data.total,
                                        })
                                    }

                                })
                        })
                    }
                    onSearchChange={setQuery}
                    onChangePage={(page, size) => {
                        // console.log("page", page)
                        // console.log("size", size)

                    }}
                    actions={[
                        rowData => ({
                            icon: 'edit',
                            tooltip: t("detail_edit_record_tip"),
                            onClick: (event, rowData) => handleFormOpen(rowData.id),
                            disabled: rowData.status == "1" ? true : !hasGetPerm
                        }),
                        rowData => ({
                            icon: 'delete',
                            tooltip: t("detail_delete_record_tip"),
                            onClick: (event, rowData) => openDialogBox(rowData.id),
                            disabled: rowData.status == "1" ? true : !hasDeletePerm
                        }),
                        {
                            icon: 'print',
                            tooltip: t("detail_print_record_tip"),
                            onClick: (event, rowData) => InvoicePrint(rowData, configData)
                        }
                        //add collect button
                    ]}
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        debounceInterval: 500,
                        paging: true,
                    }}
                    isLoading={loading}
                    components={{
                        Pagination: PatchedPagination,
                    }}
                />

                <Fab color="primary" aria-label="add" className={classes.fab} onClick={handleFormOpen}

                    disabled={!hasAddPerm}
                >

                    <AddIcon />
                </Fab>
            </Grid>
        </Grid>
    )
}

export default InvoiceTable;